import React, { useState, useSyncExternalStore } from 'react';
import { CloudOffIcon, RefreshCwIcon } from 'lucide-react';
import { manualRefresh, realtimeStatus, subscribeRealtimeStatus } from '../../services/realtime';
const LABELS = {
  sincronizado: 'Sincronizado',
  actualizando: 'Actualizando',
  sin_conexion: 'Sin conexión'
} as const;

/**
 * Indicador discreto del estado de la sincronización en tiempo real, con un
 * botón de actualización manual como respaldo si el canal falla.
 */
export function SyncStatus() {
  const status = useSyncExternalStore(subscribeRealtimeStatus, realtimeStatus, realtimeStatus);
  const [refreshing, setRefreshing] = useState(false);
  const busy = refreshing || status === 'actualizando';
  async function handleRefresh() {
    setRefreshing(true);
    try {
      await manualRefresh();
    } finally {
      setRefreshing(false);
    }
  }
  const dotClass = status === 'sincronizado' ? 'bg-green-500' : status === 'actualizando' ? 'bg-amber-500' : 'bg-red-500';
  return <div className="flex items-center gap-1.5" data-id="element-1099" data-mp="h3t8xhrp99sp">
      <span className="hidden items-center gap-1.5 rounded-full border border-border px-2.5 py-1 text-xs text-muted-foreground sm:flex" role="status" aria-live="polite" data-id="element-1100" data-mp="h4mjktts4jg4">
        {status === 'sin_conexion' ? <CloudOffIcon className="h-3.5 w-3.5 text-red-500" aria-hidden="true" data-id="element-1101" data-mp="r3twjfwlqc2p" /> : <span className={`h-2 w-2 rounded-full ${dotClass}`} aria-hidden="true" data-id="element-1102" data-mp="m2e7zdv7tnfk" />}
        {LABELS[status]}
      </span>
      <button type="button" onClick={handleRefresh} disabled={busy} aria-label="Actualizar datos" title="Actualizar datos" className="flex h-9 w-9 items-center justify-center rounded-md text-muted-foreground transition-colors hover:bg-surface hover:text-foreground disabled:opacity-50" data-id="element-1103" data-mp="101nqwlat2vn8">
        <RefreshCwIcon className={`h-4 w-4 ${busy ? 'animate-spin' : ''}`} aria-hidden="true" data-id="element-1104" data-mp="14v8erkioq98p" />
      </button>
    </div>;
}